const getLineType = strokeDashArray => {
  switch (true) {
    case strokeDashArray === "none":
      return "Solid";
    case strokeDashArray
      .split(",")
      .map(Number)
      .every((val, i, arr) => val === arr[0]):
      return "Dash";
    case /^0/.test(strokeDashArray):
      return "Dot";
    default:
      return "Solid";
  }
};

export { getLineType };
